import { Endpoint } from '@business/api/endpoint';
import { DiscountTypeId, DiscountTypeRequest, DiscountTypeResponse } from '@business/entities/tm';

export function fetchDiscountTypes() {
  return Endpoint.get<DiscountTypeResponse[]>(`@gc/discount-types`);
}

export function createDiscountType(data: DiscountTypeRequest) {
  return Endpoint.post<DiscountTypeResponse[]>(`@gc/discount-types`, { data });
}

// changeNote: the reason for the change (required, kept in the Activity Log)
export function updateDiscountType(id: DiscountTypeId, data: DiscountTypeRequest, changeNote: string) {
  return Endpoint.patch<DiscountTypeResponse[]>(`@gc/discount-types/${id}`, { data: { ...data, changeNote } });
}

export function deleteDiscountType(id: DiscountTypeId, changeNote: string) {
  return Endpoint.delete<{ success: boolean }>(`@gc/discount-types/${id}`, { data: { changeNote } });
}

export function sortDiscountTypes(ids: DiscountTypeId[]) {
  return Endpoint.post<DiscountTypeResponse[]>(`@gc/discount-types/sort`, { data: { ids } });
}
